import { render, staticRenderFns } from "./ProjectCreated.vue?vue&type=template&id=49e4d757"
import script from "./ProjectCreated.vue?vue&type=script&lang=js"
export * from "./ProjectCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports